import React, { useEffect, useRef, useState } from 'react'
import { Card } from 'react-bootstrap'

import useTranslation from '../../Hooks/UseTranslation';

import KanbanTaskCard from './KanbanTaskCard';
import KanbanCollapsible from './KanbanCollapsible';

import DiamondSvg from "../../Components/SvgImages/Diamond";

import './KanbanMonth.scss'

interface Props {
  title: string;
  tasks: any[];
  onSelectTask: (task_id: string) => void;
}

type TaskFilterKey = 'milestone' | 'activa' | 'activa-atrasada' | 'liberada' | 'atrasada' | 'pendiente' | 'completada'

const KanbanMonth = (props: Props) => {
  const {
    title,
    tasks: _tasks,
    onSelectTask
  } = props

  const { t } = useTranslation()

  const [ tasks, setTasks ] = useState<any[]>([])
  const [ filters, setFilters ] = useState<string[]>([])
  const [ activeFilters, setActiveFilters ] = useState<string[]>([])

  const toggleFilter = (filter: string) => {

    const filters = [...activeFilters]

    if (filters.includes(filter)) {

      filters.splice(filters.indexOf(filter), 1)
    } else {

      filters.push(filter)
    }

    setActiveFilters(filters)
  }

  const getTasksNumberByStatus = (status: string) => {

    let tasksNumber = 0

    _tasks.forEach((task: any) => {

      if (status === 'milestone' && task.type === 'hito') {

        tasksNumber += 1
        return
      }

      if (task.status === status) {

        tasksNumber += 1
      }
    })

    return tasksNumber
  }

  const types: any = {
    milestone: {
      icon: (<DiamondSvg width={15} height={15} />),
      title: t('TASK_TYPES:Milestone'),
      className: 'milestone',
      onClick: () => toggleFilter('milestone')
    },
    activa: {
      icon: (<span className='icon-estado_activa' />),
      title: t('TASKS_GROUP_BY_STATUS:ActiveStatus'),
      className: 'activa',
      onClick: () => toggleFilter('activa')
    },
    'activa-atrasada': {
      icon: (<span className='icon-estado_activa_atrasada' />),
      title: t('TASKS_GROUP_BY_STATUS:ActiveOverdueStatus'),
      className: 'activa-atrasada',
      onClick: () => toggleFilter('activa-atrasada')
    },
    liberada: {
      icon: (<span className='icon-estado_liberada' />),
      title: t('TASKS_GROUP_BY_STATUS:ReleasedStatus'),
      className: 'liberada',
      onClick: () => toggleFilter('liberada')
    },
    atrasada: {
      icon: (<span className='icon-estado_atrasada text-color-atrasada' />),
      title: t('TASKS_GROUP_BY_STATUS:OverdueStatus'),
      className: 'atrasada',
      onClick: () => toggleFilter('atrasada')
    },
    pendiente: {
      icon: (<span className='icon-estado_pendiente' />),
      title: t('TASKS_GROUP_BY_STATUS:PendingStatus'),
      className: 'pendiente',
      onClick: () => toggleFilter('pendiente')
    },
    completada: {
      icon: (<span className='icon-estado_completada' />),
      title: t('TASKS_GROUP_BY_STATUS:CompletedStatus'),
      className: 'completada',
      onClick: () => toggleFilter('completada')
    }
  }

  useEffect(() => {
    setTasks(_tasks)
  }, [_tasks])

  useEffect(() => {

    const getFilters = () => {

      const filters: TaskFilterKey[] = []

      _tasks.forEach((task: any) => {

        if (task.type === 'hito') {

          if (!filters.includes('milestone')) {

            filters.push('milestone')
          }
        }

        if (task.type !== 'hito' && task.type !== 'reunion') {

          if (!filters.includes(task.status)) {

            filters.push(task.status)
          }
        }
      })

      setFilters(filters)
      setActiveFilters([...filters])
    }

    getFilters()
  }, [_tasks])

  useEffect(() => {

    const filterTasks = () => {

      console.log('filtering tasks')

      const filteredTasks: any[] = []

      _tasks.forEach((task: any) => {

        if (task.type === 'hito' && activeFilters.includes('milestone')) {

          filteredTasks.push(task)
          return
        }

        if (activeFilters.includes(task.status)) {

          filteredTasks.push(task)
          return
        }
      })

      setTasks(filteredTasks)
    }

    filterTasks()
  }, [activeFilters])

  return (
    <KanbanCollapsible
      title={title}
      types={types}
      filters={filters}
      activeFilters={activeFilters}
      onFilterChange={toggleFilter}
    >
      {tasks.map((task: any) => (
        <KanbanTaskCard key={task._id}
          task={task}
          responsibles={task.responsibles}
          onClick={onSelectTask}
        />
      ))}
    </KanbanCollapsible>
  )
}

export default KanbanMonth
